import { pageTitle } from 'ember-page-title';
import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';

class EsportsRouteComponent extends Component {
  <template>
    {{pageTitle 'eSports'}}
    {{outlet}}
  </template>
}

export default RouteTemplate(EsportsRouteComponent);
